import { useQuery } from '@tanstack/react-query'
import {
	type GetFinalReviewListingDetailsParams,
	httpGetFinalReviewListingDetails
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const FINAL_REVIEW_LISTING_DETAILS_QUERY_KEY =
	'final-review-listing-details'

export const useGetFinalReviewListingDetails = (
	params: GetFinalReviewListingDetailsParams = {}
) =>
	useQuery({
		queryKey: [FINAL_REVIEW_LISTING_DETAILS_QUERY_KEY, params],
		queryFn: () => httpGetFinalReviewListingDetails(params)
	})
